import React from 'react';
import styled from 'styled-components';
import { Alert } from 'reactstrap';
import { Carousel } from 'react-responsive-carousel';
import bank_of_nd from './images/Bank_ND_Web.jpg';
import bobcat from './images/Bobcat_Web.jpg';
import proximal from './images/Proximal_Web.jpg';

// carousel styles
import 'react-responsive-carousel/lib/styles/carousel.css';

const HeroImg = styled.img`
  width: 100%;
`;

const Hero = () => {
  return (
    <div>
      {/* <Alert color="warning">
        <h2>Lobby Closure</h2>
        <p>
          Due to Covid-19 virus, the safety of our employees and in support of
          social distancing guidance by the CDC, our lobby will be CLOSED to the
          public until further notice.
        </p>
        <p>Deliveries will be accepted at the North end of the building.</p>
        <p>
          A letter listing additional steps Red River Glazing is taking can be
          viewed here: 
          <a href="http://bit.ly/RRGCOVID19RESPONSE">
            bit.ly/RRGCOVID19RESPONSE
          </a>
        </p>
  </Alert>*/}
      <Carousel
        showArrows={true}
        transitionTime={1000}
        infiniteLoop
        showThumbs={false}
        showIndicators={false}
      >
        <div>
          <HeroImg src={bank_of_nd} />
        </div>
        <div>
          <HeroImg src={bobcat} />
        </div>
        <div>
          <HeroImg src={proximal} />
        </div>
      </Carousel>
    </div>
  );
};

export default Hero;



// WEBPACK FOOTER //
// ./src/Hero.js